import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_J_CASH_IN = '/spe-j-cash-in';
let SpeJCashInProxy = class SpeJCashInProxy {
    constructor(api) {
        this.api = api;
    }
    generateBillet(value, uuidAccountPaymet, uuidWhitelabel) {
        const uri = `${SPE_J_CASH_IN}/api/self-billet-cash-in`;
        return this.api.post(uri, {
            value,
            uuidAccountPaymet,
            uuidWhitelabel
        });
    }
    /**
     * Metodo usado para geracao dos boletos de terceiros (como boletos de cobranca)
     * @param body
     */
    generateBilletWithObject(body) {
        const uri = `${SPE_J_CASH_IN}/api/self-billet-cash-in`;
        return this.api.post(uri, body);
    }
    getBilletsByUuidAccountPayment(uuidAccountPayment) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/type/${type}`;
        return this.api.get(uri);
    }
    getBilletsByUuid(uuid) {
        const uri = `${SPE_J_CASH_IN}/api/billets/uuid-billet/${uuid}`;
        return this.api.get(uri);
    }
    getBilletsByTransactionId(transactionId) {
        const uri = `${SPE_J_CASH_IN}/api/billets/transaction-id/${transactionId}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/period/?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/type/${type}/period/?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/finished/${isFinished}/period/?startDate=${dateInitial}&endDate=${dateEnd} `;
        return this.api.get(uri);
    }
    getAllStatusDataByStatus(uuidAccountPayment, type, status, dateInitial, dateEnd) {
        const uri = `${SPE_J_CASH_IN}/api/billets/account-payment/${uuidAccountPayment}/type/${type}/status/${status}?startDate=${dateInitial}&endDate=${dateEnd} `;
        return this.api.get(uri);
    }
    getAllStatusDataByUuidAccountPaymentLotBillet(uuidAccountPayment, uuidAccountPaymentLotBillet, type, status) {
        const uri = `${SPE_J_CASH_IN}/api/billets/lot/${uuidAccountPaymentLotBillet}/account-payment/${uuidAccountPayment}/type/${type}/status/${status}`;
        return this.api.get(uri);
    }
    getBilletDownload(transactionId) {
        const uri = `${SPE_J_CASH_IN}/api/billets/download/transaction-id/${transactionId}`;
        return this.api.getBlob(uri);
    }
    getBilletDownloadLot(uuidLot) {
        const uri = `${SPE_J_CASH_IN}/api/billets/download/lot-billet//${uuidLot}`;
        return this.api.getBlob(uri);
    }
};
SpeJCashInProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCashInProxy);

const SPE_J_CHECK_EVENT = '/spe-j-check-event';
let SpeJCheckEventProxy = class SpeJCheckEventProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * @description Valida se a operação está autorizada
     * @param checkEventBody
     */
    validateOperation(checkEventBody) {
        const uri = `${SPE_J_CHECK_EVENT}/api/check-event/`;
        return this.api.post(uri, checkEventBody);
    }
};
SpeJCheckEventProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCheckEventProxy);

const SPE_J_FUNDS = '/spe-j-funds';
let SpeJFundsProxy = class SpeJFundsProxy {
    constructor(api) {
        this.api = api;
    }
    getCheckBalance(uuidWhilabel, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/check-balance/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getSumMoviments(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/check-sum-moviments/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/start-date/${dateInitial}/end-date/${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatement(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getLatestTransaction(uuidWhilabel, uuidAccountPayment, quantityRegisters) {
        const uri = `${SPE_J_FUNDS}/api/statement/last-registers/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/number/${quantityRegisters}`;
        return this.api.get(uri);
    }
    getBalanceCashback(uuidWhilabel, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/cash-back/check-balance/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeJFundsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJFundsProxy);

const SPE_N_ACCOUNT = '/spe-n-account';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getNotifications(uuid) {
        return [];
    }
    confirmReading(uuid, notification) {
        const uri = `${SPE_N_ACCOUNT}/v1/notificatios/${uuid}`;
        return this.api.put(uri, notification);
    }
    getNotificationData(uuidAccount) {
        return [{
                uuidNotification: "123123123213",
                type: 1,
                account_owner: "Dono Da Conta TED",
                transfer_value: 50,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123243",
                type: 2,
                account_owner: "Dono Da Conta ON_US",
                transfer_value: 50,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123214",
                type: 3,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123215",
                type: 4,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                type: 5,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                type: 6,
                establishment: "estabelecimento Estabelecimento",
                value: 1250,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                third_party: "terceiro Terceiro",
                value: 500,
                type: 7,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                third_party: "terceiro Terceiro",
                value: 500,
                type: 8,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                type: 9,
                third_party: "terceiro Terceiro",
                value: 6700,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                third_party: "terceiro Terceiro",
                value: 540,
                type: 10,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                dateFormatted: "05/05/1999",
                type: 11,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                phone_number: "(23) 9999-4444",
                value: 540,
                type: 12,
                date: (new Date()).getDate()
            }, {
                uuidNotification: "123123123216",
                white_label: "LogBank",
                type: 13,
                date: (new Date()).getDate()
            }];
    }
};
SpeNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountProxy);

const SPE_N_ACCOUNT$1 = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    generateQrcode(uuidAccountPayment, value) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/generate-qr-onus`;
        return this.api.post(uri, { uuidAccountPayment, value });
    }
    statusQrcode(encode) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/status-qr-onus/${encode}`;
        return this.api.post(uri, {});
    }
    /**
     * remove o cartao da wallet
     * @param uuidCard
     * @returns
     */
    deleteWalletCard(uuidCard) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/wallet/delete/${uuidCard}`;
        return this.api.put(uri, {});
    }
};
SpeNAccountsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountsProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCardTax(uuidWhiteLabel, uuidAccountPayment, codeOperation) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/taxes-tariff/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/code-operation/${codeOperation}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountProxy);

const SPE_VIEW_N_DASHBOARD_CLIENT = '/spe-view-n-dashboard-client';
let SpeViewNDashboardClientProxy = class SpeViewNDashboardClientProxy {
    constructor(api) {
        this.api = api;
    }
    getCashback(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeViewNDashboardClientProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNDashboardClientProxy);

const SPE_N_IMPORTATION_BILLET = '/spe-n-importation-billet';
let SpeNImportationBilletProxy = class SpeNImportationBilletProxy {
    constructor(api) {
        this.api = api;
    }
    batchBillsModel$(format) {
        const uri = `${SPE_N_IMPORTATION_BILLET}/v1/billet/download`;
        return format == 'pdf' ? this.api.get(uri) : this.api.getBlob(uri);
    }
    postbatchBillsModel$(body, uuidWhiteLabel) {
        const uri = `${SPE_N_IMPORTATION_BILLET}/v1/billet/upload/${uuidWhiteLabel}`;
        return this.api.post(uri, body);
    }
    confirmLotBillet(uuidLotBillet, authorizationCode) {
        const uri = `${SPE_N_IMPORTATION_BILLET}/v1/generate-lot-billet/uuid/${uuidLotBillet}/authorizationCode/${authorizationCode}`;
        return this.api.post(uri);
    }
};
SpeNImportationBilletProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNImportationBilletProxy);

const SPE_VIEW_N_BILLET = '/spe-view-n-billet';
let SpeViewNBilletProxy = class SpeViewNBilletProxy {
    constructor(api) {
        this.api = api;
    }
    // Tipar os objetos de retorno após a criação dos serviços
    getLotBillets(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_BILLET}/v1/lot-billet/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    // Tipar os objetos de retorno após a criação dos serviços
    getLot(uuidLot) {
        const uri = `${SPE_VIEW_N_BILLET}/v1/billet/${uuidLot}`;
        return this.api.get(uri);
    }
    removeLotBillets(uuidLot) {
        const uri = `${SPE_VIEW_N_BILLET}/v1/billet/${uuidLot}`;
        return this.api.delete(uri);
        //return this.api.put(uri, {});
    }
    /**
    * @description Teste Build
    */
    getListBilletsLot(uuidAccountPayment, uuidAccountPaymentLotBillet) {
        const uri = `${SPE_VIEW_N_BILLET}/v1/billet/account-payment/${uuidAccountPayment}/account-payment-lot-billet/${uuidAccountPaymentLotBillet}`;
        return this.api.get(uri);
    }
    getLotsByAccountPayment(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_BILLET}/v2/lots/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getLots(startDate, endDate, status, searchText) {
        let params = '';
        if (startDate) {
            params += `?startDate=${startDate}`;
        }
        if (endDate) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}endDate=${endDate}`;
        }
        if (status) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}status=${status}`;
        }
        if (searchText) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}searchText=${searchText}`;
        }
        const uri = `${SPE_VIEW_N_BILLET}/v2/lots${params}`;
        return this.api.get(uri);
    }
    getLotsPaginated(startDate, endDate, status, searchText, paginationParams) {
        let params = '';
        if (startDate) {
            params += `?startDate=${startDate}`;
        }
        if (endDate) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}endDate=${endDate}`;
        }
        if (status) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}status=${status}`;
        }
        if (searchText) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}searchText=${searchText}`;
        }
        if (paginationParams) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}page=${paginationParams.page}&itemsPerPage=${paginationParams.itemsPerPage}`;
        }
        const uri = `${SPE_VIEW_N_BILLET}/v2/lots-paginated${params}`;
        return this.api.get(uri);
    }
    getLotWithBilletsByLotUuid(uuidAccountPayment, uuidLot) {
        const uri = `${SPE_VIEW_N_BILLET}/v2/lot/${uuidAccountPayment}/${uuidLot}`;
        return this.api.get(uri);
    }
    getChargingBillets(startDate, endDate, status, searchText) {
        let params = `?startDate=${startDate}&endDate=${endDate}`;
        if (status) {
            params += `&status=${status}`;
        }
        if (searchText) {
            params += `&searchText=${searchText}`;
        }
        const uri = `${SPE_VIEW_N_BILLET}/v2/charging-billets${params}`;
        return this.api.get(uri);
    }
    getChargingBilletsPaginated(startDate, endDate, status, searchText, paginationParams) {
        let params = `?startDate=${startDate}&endDate=${endDate}`;
        if (status) {
            params += `&status=${status}`;
        }
        if (searchText) {
            params += `&searchText=${searchText}`;
        }
        if (paginationParams) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}page=${paginationParams.page}&itemsPerPage=${paginationParams.itemsPerPage}`;
        }
        const uri = `${SPE_VIEW_N_BILLET}/v2/charging-billets/paginated${params}`;
        return this.api.get(uri);
    }
    findByUuidBilletV2(uuidBillet) {
        const uri = `${SPE_VIEW_N_BILLET}/v2/of-uuid/${uuidBillet}`;
        return this.api.get(uri);
    }
    getExportXlsx(startDate, endDate, status, searchText) {
        let paramComplemetary = '';
        if (status)
            paramComplemetary += `&status=${status ? status : ''}`;
        if (searchText)
            paramComplemetary += `&searchText=${searchText ? searchText : ''}`;
        const uri = `${SPE_VIEW_N_BILLET}/v2/download/report?startDate=${startDate}&endDate=${endDate}${paramComplemetary}`;
        return this.api.getBlob(uri);
    }
};
SpeViewNBilletProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNBilletProxy);

const SPE_N_ACCOUNT_CONSIGNED = '/spe-n-account-consigned';
let SpeNConsignedCalculatorProxy = class SpeNConsignedCalculatorProxy {
    constructor(api) {
        this.api = api;
    }
    createSimulation(uuid, value, hasInsurance, uuidWhiteLabel) {
        const uri = `${SPE_N_ACCOUNT_CONSIGNED}/v1/simulation/app/`;
        return this.api.post(uri, { "uuid": uuid, "value": value, "hasInsurance": hasInsurance, uuidWhiteLabel });
    }
    requestProposal(id, installmentNumber, body) {
        const uri = `${SPE_N_ACCOUNT_CONSIGNED}/v1/proposals/generate/${id}/${installmentNumber}`;
        return this.api.post(uri, body);
    }
    getPreApproved(uuid) {
        const uri = `${SPE_N_ACCOUNT_CONSIGNED}/v1/simulation/pre-approved/`;
        return this.api.post(uri, { uuid });
    }
    getSimulation() {
        const uri = `${SPE_N_ACCOUNT_CONSIGNED}/v1/all-simulation/`;
        return this.api.get(uri);
    }
    signProsposal(data) {
        const uri = `${SPE_N_ACCOUNT_CONSIGNED}/v1/proposals/sign`;
        return this.api.post(uri, data);
    }
};
SpeNConsignedCalculatorProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNConsignedCalculatorProxy);

const SPE_VIEW_N_ACCOUNT_CONSIGNED = '/spe-view-n-account-consigned';
let SpeViewNAccountConsigned = class SpeViewNAccountConsigned {
    constructor(api) {
        this.api = api;
    }
    getSimulation() {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/all-simulation/`;
        return this.api.get(uri);
    }
    findAllSimulationsSpecialByUuidCustomer() {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/all-special-simulation-by-account`;
        return this.api.get(uri);
    }
    getProposal() {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/proposal/uuidAccountPayment/`;
        return this.api.get(uri);
    }
    findUuidAccountPaymentLastProposalPendingSign() {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/proposal/findUuidAccountPaymentLastProposalPendingSign/`;
        return this.api.get(uri);
    }
    getContracts() {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/contract/find/uuidAccountPayment/`;
        return this.api.get(uri);
    }
    getSimulationStatus(uuidCostumer, statusSimulation) {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/simulation/${uuidCostumer}/AndStatus/${statusSimulation}`;
        return this.api.get(uri);
    }
    getAprovationHistory(uuidProposal) {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/proposal/find/aprovation-history/${uuidProposal}`;
        return this.api.get(uri);
    }
    getContractProsposal(uuidWhiteLabel, installmentsNumber, idSimulation) {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/proposal/find/contract-terms/${uuidWhiteLabel}/${installmentsNumber}/${idSimulation}`;
        return this.api.get(uri);
    }
    getContractTerms(uuid) {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/contract/find/contract-terms/${uuid}`;
        return this.api.get(uri);
    }
    getCCB(uuidProposal) {
        const uri = `${SPE_VIEW_N_ACCOUNT_CONSIGNED}/v1/proposal/ccb/${uuidProposal}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountConsigned = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountConsigned);

const SPE_N_BILLET = '/spe-n-billet';
let SpeNBilletProxy = class SpeNBilletProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * Método responsável por criar o lote de boletos como rascunho
     */
    createLot(createLotRequestDto) {
        const uri = `${SPE_N_BILLET}/v1/lot`;
        return this.api.post(uri, createLotRequestDto);
    }
    updateValue(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-value`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateDueDate(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-date-due`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateRequestNumber(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-request-number`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateLimitDate(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-date-limit`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateFees(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-fees`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateFine(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-fine`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateDiscount(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-discount`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateProtest(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-protest`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updatePayer(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-payer`;
        return this.api.put(uri, { uuidBillet, body });
    }
    updateAbatement(uuidBillet, body) {
        const uri = `${SPE_N_BILLET}/v1/billet/update-abatement`;
        return this.api.put(uri, { uuidBillet, body });
    }
    emitLot(emitLotRequest) {
        const uri = `${SPE_N_BILLET}/v1/lot/emit`;
        return this.api.post(uri, emitLotRequest);
    }
    cancelBillet(body) {
        const uri = `${SPE_N_BILLET}/v1/billet/cancel`;
        return this.api.put(uri, body);
    }
    immediateDischarge(body) {
        const uri = `${SPE_N_BILLET}/v1/billet/immediate-discharge`;
        return this.api.put(uri, body);
    }
    cancelBilletLot(body) {
        const uri = `${SPE_N_BILLET}/v1/lot/cancel`;
        return this.api.put(uri, body);
    }
};
SpeNBilletProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNBilletProxy);

const SPE_N_FGTS = '/spe-n-fgts';
let SpeNFGTSProxy = class SpeNFGTSProxy {
    constructor(api) {
        this.api = api;
    }
    customAmountSimulation(body) {
        const uri = `${SPE_N_FGTS}/v1/simulation/custom-amount`;
        return this.api.post(uri, body);
    }
    simulation(body) {
        const uri = `${SPE_N_FGTS}/v1/simulation`;
        return this.api.post(uri, body);
    }
    requestProposal(body) {
        const uri = `${SPE_N_FGTS}/v1/proposal-inclusion`;
        return this.api.post(uri, body);
    }
    cancelProposal(body) {
        const uri = `${SPE_N_FGTS}/v1/request-cancelation`;
        return this.api.post(uri, body);
    }
    /* getPreApproved(uuid: string) {
        const uri = `${SPE_N_FGTS}/v1/simulation/pre-approved/`;
        return this.api.post(uri, { uuid });
    }

    */
    signProsposal(data) {
        const uri = `${SPE_N_FGTS}/v1/sign`;
        return this.api.post(uri, data);
    }
    getCCB(uuidProposal) {
        /* /v1/find/ccb */
        const uri = `${SPE_N_FGTS}/v1/find/ccb?uuidProposal=${uuidProposal}`;
        return this.api.get(uri);
    }
};
SpeNFGTSProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNFGTSProxy);

const SPE_VIEW_N_FGTS = '/spe-view-n-fgts';
let SpeViewNFGTSProxy = class SpeViewNFGTSProxy {
    constructor(api) {
        this.api = api;
    }
    findByUuidProposal(uuidProposal) {
        const uri = `${SPE_VIEW_N_FGTS}/v1/find/ccb/uuidProposal=${uuidProposal}`;
        return this.api.get(uri);
    }
    findProposal(uuidProposal) {
        const uri = `${SPE_VIEW_N_FGTS}/v1/find/proposal`;
        return this.api.post(uri, uuidProposal);
    }
    getSimulations() {
        const uri = `${SPE_VIEW_N_FGTS}/v1/simulation/find/all-simulations`;
        return this.api.get(uri);
    }
    getAllProposalsRequested() {
        /* /v1/find/all-proposal */
        const uri = `${SPE_VIEW_N_FGTS}/v1/find/all-proposal`;
        return this.api.get(uri);
    }
    getAllContracts() {
        /* /v1/contract/find-all */
        const uri = `${SPE_VIEW_N_FGTS}/v1/contract/find-all`;
        return this.api.get(uri);
    }
    getCCB(uuidProposal) {
        /* /v1/find/ccb */
        const uri = `${SPE_VIEW_N_FGTS}/v1/find/ccb?uuidProposal=${uuidProposal}`;
        return this.api.get(uri);
    }
    getPaymentDataCancelProposal(proposalUuid) {
        const uri = `${SPE_VIEW_N_FGTS}/v1/cancel/findByUuid/${proposalUuid}`;
        return this.api.get(uri);
    }
    aprovationHistory(proposalUuid) {
        const uri = `${SPE_VIEW_N_FGTS}/v1/find/aprovation-history/${proposalUuid}`;
        return this.api.get(uri);
    }
};
SpeViewNFGTSProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNFGTSProxy);

let UiPxCashInModule = class UiPxCashInModule {
};
UiPxCashInModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [
            SpeNAccountProxy,
            SpeNAccountsProxy,
            SpeJFundsProxy,
            SpeJCashInProxy,
            SpeJCheckEventProxy,
            SpeViewNAccountProxy,
            SpeViewNDashboardClientProxy,
            SpeNImportationBilletProxy,
            SpeViewNBilletProxy,
            ConfigService,
            SpeNConsignedCalculatorProxy,
            SpeViewNAccountConsigned,
            SpeNBilletProxy,
            SpeNFGTSProxy,
            SpeViewNFGTSProxy
        ],
    })
], UiPxCashInModule);

class CreateLotRequestDto {
}
class CreateRechargeRequestDto {
}
class BilletPayerRequestDTO {
}
class BilletFeeRequestDto {
}
class BilletFineRequestDto {
}
class BilletDiscountRequestDto {
}
class BilletDiscountDetailsRequestDto {
}
class BilletProtestRequestDto {
}
class BilletInstructionRequestDto {
}
class BilletPayerAddressRequestDto {
}

class AccountPaymentLotBilletDto {
    constructor(uuidAccountPayment, uuidWhiteLabel, name, description, status) {
        this.uuidAccountPayment = uuidAccountPayment;
        this.uuidWhiteLabel = uuidWhiteLabel;
        this.name = name;
        this.description = description;
        this.status = status;
    }
}

class CancelBilletRequestDto {
}
class ImmediateDischargeBilletRequestDto {
}
class CancelBilletLotRequestDto {
}

class AddressDto {
}
class PayerDto {
}
class FeesDto {
}
class FineDto {
}
class DiscountDto {
}
class DiscountDetailsDto {
}
class ProtestDto {
}
class BilletDto {
}

class LotBilletCompletedDto {
}

class LotWithBilletCompletedDto extends LotBilletCompletedDto {
}

class CustomAmountSimulationFgtsRequest {
}

class RequestProposalFgts {
    constructor(tokenClient, uuidSimulation, device, latitude, longitude, uuidWhiteLabel) {
        this.tokenClient = tokenClient;
        this.uuidSimulation = uuidSimulation;
        this.device = device;
        this.latitude = latitude;
        this.longitude = longitude;
        this.uuidWhiteLabel = uuidWhiteLabel;
    }
}

var LotStatusEnum;
(function (LotStatusEnum) {
    LotStatusEnum["PENDING"] = "PENDING";
    LotStatusEnum["AVAILABLE"] = "AVAILABLE";
    LotStatusEnum["IN_VALIDATION"] = "IN_VALIDATION";
    LotStatusEnum["IN_PROCESS"] = "IN_PROCESS";
    LotStatusEnum["IN_PROCESS_ERROR"] = "IN_PROCESS_ERROR";
    LotStatusEnum["DRAFT"] = "DRAFT";
    LotStatusEnum["CANCELED"] = "CANCELED";
})(LotStatusEnum || (LotStatusEnum = {}));

export { AccountPaymentLotBilletDto, AddressDto, BilletDiscountDetailsRequestDto, BilletDiscountRequestDto, BilletDto, BilletFeeRequestDto, BilletFineRequestDto, BilletInstructionRequestDto, BilletPayerAddressRequestDto, BilletPayerRequestDTO, BilletProtestRequestDto, CancelBilletLotRequestDto, CancelBilletRequestDto, ConfigService, CreateLotRequestDto, CreateRechargeRequestDto, CustomAmountSimulationFgtsRequest, DiscountDetailsDto, DiscountDto, FeesDto, FineDto, ImmediateDischargeBilletRequestDto, LotBilletCompletedDto, LotWithBilletCompletedDto, PayerDto, ProtestDto, RequestProposalFgts, SpeJCashInProxy, SpeJCheckEventProxy, SpeJFundsProxy, SpeNAccountProxy, SpeNAccountsProxy, SpeNBilletProxy, SpeNConsignedCalculatorProxy, SpeNFGTSProxy, SpeNImportationBilletProxy, SpeViewNAccountConsigned, SpeViewNAccountProxy, SpeViewNBilletProxy, SpeViewNDashboardClientProxy, SpeViewNFGTSProxy, UiPxCashInModule, LotStatusEnum as ɵa };
//# sourceMappingURL=wlp-ui-px-cashin.js.map
